import { Outlet, Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import i18next, { use } from "i18next";
import { RootLayout } from "./components/RootLayout";

import "./styles/tailwind.css";
const Layout = () => {
  const [isCursor, setIsCursor] = useState(false);
  const [dir, setDir] = useState("ltr");

  useEffect(() => {
    const currentLanguage = i18next.language;
    if (currentLanguage === "ar") {
      setDir("rtl");
    } else {
      setDir("ltr");
    }

    const handleLanguageChange = (lng) => {
      if (lng === "ar") {
        setDir("rtl");
      } else {
        setDir("ltr");
      }
    };

    i18next.on("languageChanged", handleLanguageChange);

    return () => {
      i18next.off("languageChanged", handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    const coords = { x: 0, y: 0 };
    const circles = document.querySelectorAll(".circle");

    const colors = [
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
      "#000",
    ];

    circles.forEach(function (circle, index) {
      circle.x = 0;
      circle.y = 0;
      circle.style.backgroundColor = colors[index % colors.length];
    });

    window.addEventListener("mousemove", function (e) {
      coords.x = e.clientX;
      coords.y = e.clientY;

      let elementUnderCursor = document.elementFromPoint(coords.x, coords.y);
      while (elementUnderCursor) {
      if (elementUnderCursor.classList.contains("dark-section")) {
        circles.forEach((circle) => {
        circle.style.backgroundColor = "#fff"; // Change cursor color to white
        });
        return;
      }
      elementUnderCursor = elementUnderCursor.parentElement;
      }

      circles.forEach((circle) => {
      circle.style.backgroundColor = "#000"; // Change cursor color to black
      });
    });

    function animateCircles() {
      let x = coords.x;
      let y = coords.y;

      circles.forEach(function (circle, index) {
        circle.style.left = x - 3 + "px";
        circle.style.top = y + 0 + "px";

        circle.style.scale = (circles.length - index) / circles.length;

        circle.x = x;
        circle.y = y;

        const nextCircle = circles[index + 1] || circles[0];
        x += (nextCircle.x - x) * 0.3;
        y += (nextCircle.y - y) * 0.3;
      });

      requestAnimationFrame(animateCircles);
    }

    animateCircles();
  }, [isCursor]);

  return (
    <div className="bg-neutral-950">
      <div className="max-lg:hidden ">
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
      </div>
      <RootLayout>
        <Outlet />
      </RootLayout>
    </div>
  );
};

export { Layout };